import { Routes } from '@angular/router';
import { SubscriptionAccessGuard } from './features/subscription/guards/subscription-access.guard';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./features/home/home.component')
      .then(m => m.HomeComponent)
  },
  {
    path: 'subscription',
    children: [
      {
        path: '',
        loadComponent: () => import('./features/subscription/subscription.component')
          .then(m => m.SubscriptionComponent),
        canActivate: [SubscriptionAccessGuard]
      },
      {
        path: 'waiting',
        loadComponent: () => import('./features/subscription/components/subscription-waiting/subscription-waiting.component')
          .then(m => m.SubscriptionWaitingComponent)
      }
    ]
  },
  {
    path: 'onboarding',
    loadChildren: () => import('./features/onboarding/onboarding.routes')
      .then(m => m.onboardingRoutes)
  },
  {
    path: '**',
    redirectTo: ''
  }
];
